<div class="col-12">
    <div class="row">
        <div class="col-7 pt-4 px-4">
            <h3>{{selectedWhiteLabelName}}</h3>
        </div>
        <ng-container *ngIf="user !== undefined && user.isSystemAdmin">
            <div class="col-5 pt-3">
                <button type="submit" id="changeWhiteLabel" translate="Button.ChangeWLProvider" class="btn btn-sm btn-secondary float-end me-4" (click)="openChangeWhiteLabelModal()"></button>
            </div>
        </ng-container>
    </div>
    <div class="p-1 col-12">
        <div class="bg-white p-2 h-100">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>